/**
 * Toasts each minor contract violation as the reporter raises it. Mount once, at the app root
 * beside the other toasts; the reporter raises one only where LOUD_SCHEMA_ERRORS is on.
 */

import { useEffect } from 'react';
import { toast } from 'sonner';

import { contractReporter } from '@/api/contractReporter';
import { getViolationText, LOUD_SCHEMA_ERRORS_NOTE } from '@/lib/violationText';
import type { Unsubscribe } from '@/types/common';
import type { GradedViolation } from '@/types/contract';

function showMinorViolation(violation: GradedViolation): void {
    toast.warning('Minor contract violation', {
        description: `${getViolationText(violation)}. ${LOUD_SCHEMA_ERRORS_NOTE}`,
    });
}

export function useContractViolationToasts(): void {
    useEffect((): Unsubscribe => contractReporter.subscribeMinor(showMinorViolation), []);
}
